var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext, useEffect, useState } from "react";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, Flex, Text, Box, Table, Thead, Tr, Th, Tbody, Td, SkeletonText, Spacer, IconButton, } from "@reverb-ui/react";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "@reverb-ui/icons-react";
import { ClientWalletContext } from "../context-api/providers/client-wallet";
import { BalanceContext } from "@/shared/presentation/context-api/providers/balance";
import { formatCurrency } from "@/shared/utils";
export var ModalSelectWallet = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose;
    var t = useTranslation().t;
    var _b = useContext(ClientWalletContext), clientWallets = _b.clientWallets, setSelectedClientWallet = _b.setSelectedClientWallet;
    var getBalanceByWallet = useContext(BalanceContext).getBalanceByWallet;
    var _c = useState([]), balances = _c[0], setBalances = _c[1];
    var _d = useState([]), initalBalances = _d[0], setInitalBalances = _d[1];
    useEffect(function () {
        var newBalances = clientWallets.map(function (clientWallet) {
            return {
                walletUuid: clientWallet === null || clientWallet === void 0 ? void 0 : clientWallet.walletUuid,
                loaded: false,
                balance: 0,
            };
        });
        setInitalBalances(newBalances);
        setBalances(newBalances);
    }, [clientWallets]);
    useEffect(function () {
        loadingBalances();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initalBalances]);
    var loadingBalances = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newBalances;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(initalBalances.map(function (initualBalance) { return __awaiter(void 0, void 0, void 0, function () {
                        var balance;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, getBalanceByWallet(initualBalance === null || initualBalance === void 0 ? void 0 : initualBalance.walletUuid)];
                                case 1:
                                    balance = _a.sent();
                                    return [2 /*return*/, __assign(__assign(__assign({}, initualBalance), balance), { loaded: true })];
                            }
                        });
                    }); }))];
                case 1:
                    newBalances = _a.sent();
                    setBalances(newBalances);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onClose, size: "2xl" },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, null,
            React.createElement(ModalHeader, null, t("wallet.select-wallet")),
            React.createElement(ModalBody, null,
                React.createElement(Flex, { flexWrap: "wrap" }, clientWallets.map(function (clientWallet, index) {
                    var _a, _b;
                    return (React.createElement(Box, { key: index, mb: "5", width: "100%", borderWidth: 1, borderStyle: "solid", borderRadius: 8 },
                        React.createElement(Flex, { flexWrap: "wrap" },
                            React.createElement(Box, { alignItems: "baseline" },
                                React.createElement(Text, { ml: "6", mr: "6", mt: "5", mb: "5", fontFamily: "Inter", align: "left", fontSize: "lg" }, clientWallet.name)),
                            React.createElement(Spacer, null),
                            React.createElement(Box, { alignSelf: "center" },
                                React.createElement(IconButton, { "aria-label": "Select wallet", size: "md", mr: "6", variant: "solid", icon: React.createElement(ArrowRight, { size: "md", color: "white" }), bg: "blue.500", colorScheme: "white", onClick: function () {
                                        onClose();
                                        setSelectedClientWallet(clientWallet);
                                    } }))),
                        React.createElement(Table, { variant: "simple" },
                            React.createElement(Thead, { bg: "gray.50" },
                                React.createElement(Tr, null,
                                    React.createElement(Th, { pt: "1.5", pb: "1.5" }, "WALLET"),
                                    React.createElement(Th, { pt: "1.5", pb: "1.5" }, t("wallet.credits")))),
                            React.createElement(Tbody, null,
                                React.createElement(Tr, null,
                                    React.createElement(Td, null, "Main Balance"),
                                    React.createElement(Td, null,
                                        React.createElement(SkeletonText, { width: "120px", isLoaded: ((_a = balances.find(function (b) { return b.walletUuid === (clientWallet === null || clientWallet === void 0 ? void 0 : clientWallet.walletUuid); })) === null || _a === void 0 ? void 0 : _a.loaded) || false, mr: "1" },
                                            React.createElement(Text, { fontSize: "1xl", alignSelf: "baseline" }, formatCurrency(((_b = balances.find(function (b) { return b.walletUuid === (clientWallet === null || clientWallet === void 0 ? void 0 : clientWallet.walletUuid); })) === null || _b === void 0 ? void 0 : _b.balance) || 0, {
                                                convertFromCents: true,
                                                locales: "pt-BR",
                                                currencyCode: "BRL",
                                            })))))))));
                }))))));
};
